import { useEffect, useState } from "react";
import { Add_cart,Sub_cart, Trash } from "../../../../../../assets/icons";
import "./style.css"
import useAppAccessor from "../../../../../../hooks/useappAccessor";
import useAppDispatch from "../../../../../../hooks/useAppDispatch";
import { setProductsInCart } from "../../../../../../modules/interactions/interaction.actions";

const decimalComponent = (number: any) => {
  
  if (number == undefined) return;
  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    const [integerPart, decimalPart] = numb1.toString().split(".");
    const [integerPart_2, decimalPart_2] = numb2.toString().split(".");

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart ? `${integerPart}.` : `${integerPart}`}
          { decimalPart ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
           >{`${decimalPart}`}</span> : <span> </span>
          }
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {decimalPart_2 ? `${integerPart_2}.` : `${integerPart_2}`}
          { decimalPart_2 ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span> : <span> </span>
          } 
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    const [integerPart_3, decimalPart_3] = number.toString().split(",");
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3},`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  } else {
    var [integerPart_3, decimalPart_3] = number.toString().split(".");
    if (decimalPart_3.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3}.`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  }
};



const CartListView=(props:any)=>{
  const {getInteractions, } = useAppAccessor()
  const {productDetail, productsInCart} = getInteractions();
  const dispatch = useAppDispatch();

    useEffect(()=>{
     // console.log("productsInCart in redux====>Main",productsInCart)
    },[productsInCart])
    

    const handleQtyOnclick=(isIncrease:any, data: any)=>{
     // console.log(data);
     // console.log(productsInCart);
      let cartProducts = productsInCart;
      cartProducts = cartProducts.map((item:any) => {
        if(data.sku === item?.sku) {
          if (item.quantity === 0 && !isIncrease) {
            return {
              ...item,
              quantity: -1
            };
          }
          return {
            ...item,
            quantity: isIncrease ? item.quantity + 1 : item.quantity - 1 >= 0 ? item.quantity - 1 : 0
          }
        }
        return item;
      })
        cartProducts = cartProducts.filter((item:any) => item.quantity != -1);

        dispatch(setProductsInCart(cartProducts));
      }
      

    return(
        <div>
            {
               productsInCart.map((data:any,index:any)=>{
                   return(
                <div className="flex w-full pl-2 pr-2 pt-3 pb-3 border border-[#D8D8D8] bg-white">
                  <div className="image mr-2 w-[20%]">
                    <img src={data.imageUrl} className="w-full h-full"></img>
                  </div>
                  <div className="ml-3 w-[80%]">
                    <span className="text-base txt-black font-semibold">
                    <div dangerouslySetInnerHTML={{ __html: data.name }} />  
                    </span>
                    <div className="flex justify-between mt-1 mb-1">
                      <span className={`text-lg	 text-[#595959] font-medium border border-[#979797] rounded pl-1 pr-1 pt-1 pb-1 bg-white`} >{decimalComponent(data.priceString)}</span>
                      <div  className=" flex border border-[#979797] rounded pl-1 pr-1 " style={{width:'40%',height:35}}>
                        {  data.quantity == 0 ?
                         <div onClick={()=>{handleQtyOnclick(false, data)}} style={{width:'25%',height:33}} className="bg-white flex items-center justify-center
                         border-r border-[#979797] pr-1 cursor-pointer">
                             <img src={Trash} className="cursor-pointer"
                             onClick={()=>{handleQtyOnclick(false, data)}}></img>
                         </div> :
                         <div onClick={()=>{handleQtyOnclick(false, data)}} style={{width:'25%',height:33}} className="bg-white flex items-center justify-center
                          border-r border-[#979797] pr-1 cursor-pointer">
                              <img src={Sub_cart} className="cursor-pointer"
                              onClick={()=>{handleQtyOnclick(false, data)}}></img>
                          </div>
                        }
                          <div style={{width:'50%',height:33}} className="bg-white flex items-center justify-center">
                          {data.quantity}</div>
                          <div onClick={()=>{handleQtyOnclick(true, data)}} style={{width:'25%',height:33}} className="bg-white flex items-center justify-center border-l border-[#979797] pl-1 cursor-pointer">
                          <img src={Add_cart} className="cursor-pointer"
                          onClick={()=>{handleQtyOnclick(true, data)}}></img>
                          </div>
                      </div>
                      </div>
                  </div>
                  </div>)
                  }) 
            }

              {
                props.checkoutElem
              }
           
        </div>
    )

}

export default CartListView;